import { Loadable } from 'foundations-components/transitional/utils/Loadable';
export const loadPopover = () => import( /* webpackChunkName: "approvals-popover" */'crm-pipeline-approvals-lib').then(mod => mod.PipelineApprovalsCardPopover);
const AsyncPipelineApprovalsCardPopover = Loadable({
  loader: loadPopover,
  LoadingComponent: () => null,
  ErrorComponent: () => null
});
export default AsyncPipelineApprovalsCardPopover;